<template>
    <!-- Schedule Section Style two -->
    <section class="schedule-section style-three">
        <div class="auto-container">
            <div class="sec-title text-center">
                <span class="title">Nuestros</span>
                <h2>Próximos Eventos</h2>
            </div>

            <div class="schedule-tabs style-three tabs-box">
                <div class="tabs-content">

                    <!--Tab-->
                    <div class="tab active-tab" id="tab-1">
                        <div class="schedule-timeline row">
                            <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">9.00 AM - 10.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="@/assets/img/mexico.png" alt=""></figure>
                                            <h5 class="name">Evento Uno</h5>
                                            <span class="designation">Save the Date</span>
                                        </div>
                                        <h4><a href="https://bms-mexico.videocongreso.com" target="_blank">Curso de Actualización Cardio Renal.</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="https://bms-mexico.videocongreso.com" target="_blank" class="theme-btn">Ingresar</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">10.00 AM - 11.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="@/assets/img/colombia.png" alt=""></figure>
                                            <h5 class="name">Evento por Streaming</h5>
                                            <span class="designation">Save the Date</span>
                                        </div>
                                        <h4><a href="https://bms-colombia.videocongreso.com" target="_blank">Seminario de Lactancia Materna</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="https://bms-colombia.videocongreso.com" target="_blank" class="theme-btn">Ingresar</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">11.00 AM - 12.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="@/assets/img/argentina.png" alt=""></figure>
                                            <h5 class="name">Evento Zoom</h5>
                                            <span class="designation">Save the date</span>
                                        </div>
                                        <h4><a href="https://bms-argentina.videocongreso.com" target="_blank">Curso de Actualización Pediatras</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="https://bms-argentina.videocongreso.com" target="_blank" class="theme-btn">Ingresar</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">12.00 AM - 01.00 PM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="@/assets/img/peru.png" alt=""></figure>
                                            <h5 class="name">Evento Presencial</h5>
                                            <span class="designation">Save the Date</span>
                                        </div>
                                        <h4><a @click="swop">Foro Medicina General</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a @click="swop" class="theme-btn">Ingresar</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Tab-->
                    <div class="tab" id="tab-2">
                        <div class="schedule-timeline row">
                            <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">9.00 AM - 10.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-1.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">10.00 AM - 11.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-2.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">11.00 AM - 12.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-1.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">12.00 AM - 01.00 PM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-2.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Tab-->
                    <div class="tab" id="tab-3">
                        <div class="schedule-timeline row">
                            <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">9.00 AM - 10.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-1.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">10.00 AM - 11.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-2.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">11.00 AM - 12.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-1.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">12.00 AM - 01.00 PM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-2.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Tab-->
                    <div class="tab" id="tab-4">
                        <div class="schedule-timeline row">
                            <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">9.00 AM - 10.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-1.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">10.00 AM - 11.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-2.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">11.00 AM - 12.00 AM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-1.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <!-- schedule Block -->
                            <div class="schedule-block col-lg-6 col-md-12 col-sm-12">
                                <div class="inner-box">
                                    <div class="inner">
                                        <div class="date">12.00 AM - 01.00 PM</div>
                                        <div class="speaker-info">
                                            <figure class="thumb"><img src="images/resource/thumb-2.jpg" alt=""></figure>
                                            <h5 class="name">Ashli Scroggy</h5>
                                            <span class="designation">Founder & CEO</span>
                                        </div>
                                        <h4><a href="#">Modern Marketing Summit Sydney 2018</a></h4>
                                        <div class="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmtempor incididunt labore et</div>
                                        <div class="btn-box">
                                            <a href="#" class="theme-btn">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Video v-if="show_video" url="https://player.castr.com/vod/phRVDNsRahXV00ud" @closed="closeMe"/>
    </section>
    <!--End schedule Section -->
</template>

<script>
    import Video from '@/components/Video/Video'

    export default {
        name: 'Schedule',
        components: { Video },
        data() {
            return {
                show_video: false
            }
        },
        methods: {
            closeMe: function() {
                this.swop()
            },
            swop: function() {
                this.show_video = !this.show_video
            },
        },
    }
</script>

<style scoped>
    .inneraaa {
        background: url(../../assets/img/mexico.png);
        background-position: right;
        background-size: cover;
        background-repeat: no-repeat;
        overflow: hidden;
        position: relative;
    }
    .speaker-info {
        padding-left: 140px !important;
        min-height: 100px !important;
    }
    .thumb {
        width: 100px !important;
    }
</style>